import { render, staticRenderFns } from "./modalWrapper.vue?vue&type=template&id=449c2eb3&"
import script from "./modalWrapper.vue?vue&type=script&lang=js&"
export * from "./modalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./modalWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports